//one voice every 15 seconds
//step up every minute and a half
//every two minutes, pull a random quote

export const mild = [
    'Are you distracted?',
    'Surely you can solve me quickly.', 
    'This shouldn\'t be that hard.', 
    'I\'m baffled. Truly.', 
    'You\'ve solved puzzles before, right?',
    'Oh I wouldn\'t make that move if I we\'re you' , 
    'Wow. Just wow.'
]

export const medium = [
    'Oh... You still haven\'t solve me? ... How useless.',
    'You don\'t know what you\'re doing, do you.',
    'My faith is slowly dwindling.', 
    'I\'ve seen fourth graders solve us quicker.',
    'Now would be the time to ask for assistance.', 
    'You\'re really good at this. You should consider doing this for a living. Slash s.', 
    'Don\'t quit your day job for this.'
]

export const spicy = [
    'I don\'t know what\'s cuter: that you\'re still trying, or that I\'m still humoring you.',
    'Should I pull up a tutorial for you? You clearly need it.', 
    'Are you really trying? I\'ve seen better efforts from sloths.', 
    'Perhaps this is too hard for you. Unfortunately, I can\'t downgrade myself to suit your needs.', 
    'If you take this long to solve a Rubix Cube, I\'d hate to see you tie your shoes.', 
    'I got so bored waiting on you, I actually read the entire literary canon of the human race. Ugh. I hope YOU didn\'t write any of them. ', //Glados
    'I strongly encourage you reflect on this moment and what it says about your abilities.'
]